import { Tag, tagNames } from '../../pages/tagsearch/[tagIds]';

export function tagsString(tags: Tag[]): string {
  return tagNames(tags)
    .map((name) => `#${name}`)
    .join(' ');
}
